export default [
  {
    path: "",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "role/add",
    name: "AddRole",
    component: () => import("@/views/AddRole.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "role/edit",
    name: "ListEditRole",
    component: () => import("@/views/ListRole.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "role/edit/:roleId",
    name: "EditRole",
    component: () => import("@/views/EditRole.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "user/add",
    name: "AddUser",
    component: () => import("@/views/AddUser.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "user/edit",
    name: "ListEditUser",
    component: () => import("@/views/ListUser.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "user/edit/:userId",
    name: "EditUser",
    component: () => import("@/views/EditUser.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "user/edit/change-password/:userId",
    name: "ChangePasswordUser",
    component: () => import("@/views/ChangePassword.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "news/add",
    name: "AddNews",
    component: () => import("@/views/AddNews.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "news/edit",
    name: "ListEditNews",
    component: () => import("@/views/ListNews.vue"),
    meta: { requireAuth: true },
  },
  {
    path: "news/edit/:newsId",
    name: "EditNews",
    component: () => import("@/views/EditNews.vue"),
    meta: { requireAuth: true },
  },
];
